export enum StyleConstants {
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  SMART_BETA = 'SMART_BETA',
  HEDGE = 'HEDGE',
}
